import { Box, FormControl, IconButton, ListItem, ListItemIcon, ListItemText, MenuItem, Select, TextField, Typography, makeStyles, useMediaQuery } from '@material-ui/core';
import { Clear } from '@material-ui/icons';
import React, { useEffect, useMemo, useState } from 'react';
import { formatAddressObject, personNameFormal } from 'util/format';
import { parseAddressTypeToIcons } from 'util/parseAddressIcons';

const useStyles = makeStyles(theme => ({
  wrapper: {
    whiteSpace: 'normal'
  }
})); 1
const ExistingLocations = ({
  locations,
  onSelect = () => { }
}) => {
  const classes = useStyles()
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  });

  const [value, setValue] = useState(null);

  return (
    <FormControl variant='outlined' fullWidth>
      <TextField
        variant='outlined'
        SelectProps={{
          MenuProps: {
            variant: "menu",
            getContentAnchorEl: null,
            PaperProps: {
              style: {
                maxHeight: '40vh',
                // marginLeft: isMobile?"-16px":0
              },
              square: true,
            },
          }
        }}
        select

        fullWidth
        size='small'
        placeholder="Select a previous location"
        label="Select a previous location"

        InputLabelProps={{ shrink: true }}
        onChange={event => {
          setValue(event.target.value)
          onSelect(event.target.value)
        }}
        value={value}
        InputProps={{
          endAdornment: !!value && (
            <IconButton size="small" onClick={() => {
              setValue(null)
              onSelect(null)
            }}>
              <Clear />
            </IconButton>
          )
        }}
      >
        {locations?.map((loc, i) => {
          return (
            <MenuItem key={i} value={loc}>
              <ListItem alignItems='flex-start' disableGutters divider>
                <ListItemIcon >{parseAddressTypeToIcons(loc?.type_name)}</ListItemIcon>
                <ListItemText
                  secondary={loc.name}
                  primary={<Typography variant="body2" className={classes.wrapper}>
                    {formatAddressObject(loc)}1
                  </Typography>
                  }

                />
              </ListItem>
            </MenuItem>
          )
        })}
      </TextField>
    </FormControl>

  )
}

export { ExistingLocations }